'use client';

import React, { useEffect, useState } from 'react';
import Link from 'next/link';
import { legalContentStore } from '@/lib/legalContentStore';

function renderMarkdown(text: string) {
  return text.split('\n').map((line, i) => {
    if (line.startsWith('# ')) return <h1 key={i} className="text-3xl font-bold text-white mb-4 mt-6">{line.slice(2)}</h1>;
    if (line.startsWith('## ')) return <h2 key={i} className="text-xl font-semibold text-white mb-3 mt-6">{line.slice(3)}</h2>;
    if (line.startsWith('**') && line.endsWith('**')) return <p key={i} className="text-gray-300 font-semibold my-2">{line.slice(2, -2)}</p>;
    if (line.startsWith('- ')) return <li key={i} className="text-gray-300 ml-5 list-disc my-1">{line.slice(2)}</li>;
    if (line.trim() === '') return <div key={i} className="h-3" />;
    return <p key={i} className="text-gray-300 leading-relaxed my-1">{line}</p>;
  });
}

export default function TermsOfServicePage() {
  const [content, setContent] = useState('');
  const [lastUpdated, setLastUpdated] = useState('');

  useEffect(() => {
    const doc = legalContentStore.get('terms_of_service');
    setContent(doc.content);
    setLastUpdated(doc.last_updated);
  }, []);

  return (
    <div className="min-h-screen bg-black text-white">
      <div className="max-w-3xl mx-auto px-6 py-16">
        <div className="mb-8">
          <Link href="/sign-up-login-screen" className="text-sm text-gray-400 hover:text-white transition-colors">
            ← Back to Login
          </Link>
        </div>

        <p className="text-gray-400 text-sm mb-10">Last updated: {lastUpdated}</p>

        <div className="space-y-2">
          {content ? renderMarkdown(content) : (
            <p className="text-gray-400">Loading...</p>
          )}
        </div>
      </div>
    </div>
  );
}
